import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
const painPoints = ['Vives con miedo de que a tus hijos les pase algo en la calle o saliendo del colegio', 'Te vas a dormir con la angustia de no saber si mañana va a ser un día seguro para tu familia', 'Sientes que por más que hagas, no puedes proteger a los tuyos de la inseguridad', 'Cada noticia de robo o violencia te genera más ansiedad y desesperación', 'Rezas pidiendo protección pero sientes que necesitas algo más poderoso'];
export function ProblemSection() {
  return <section className="py-16 px-4 bg-ice relative" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-122">
          <AlertTriangle className="w-12 h-12 text-blue mx-auto mb-6 opacity-80" data-id="element-123" />
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-navy-dark uppercase tracking-wide" data-id="element-124">
            ¿Te suena familiar esta sensación?
          </h2>
          <div className="w-24 h-1 bg-blue mx-auto mt-6 rounded-full opacity-60" data-id="element-125" />
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-126">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border-l-4 border-blue/80 hover:shadow-md transition-shadow" data-id="element-127">
              <CheckCircle2 className="w-6 h-6 text-blue flex-shrink-0 mt-0.5" data-id="element-128" />
              <p className="font-body text-lg text-navy leading-relaxed" data-id="element-129">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="bg-blue/5 border border-blue/20 p-8 rounded-2xl text-center" data-id="element-130">
          <p className="font-body text-xl md:text-2xl text-navy-dark leading-relaxed" data-id="element-131">
            <strong className="font-heading font-bold uppercase tracking-wider block mb-2 text-gold-dark" data-id="element-132">
              LA VERDAD ES ESTA:
            </strong>
            la inseguridad no va a desaparecer. Pero tú puedes activar una
            protección espiritual que cuide a tu familia las 24 horas, los 7
            días de la semana.
          </p>
        </motion.div>
      </div>
    </section>;
}